import { Text } from "@marketplace/ui";
import { useEffect, useState } from "react";

type CountdownTimerProps = {
  targetUnixTimestamp: number;
};

export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  targetUnixTimestamp
}) => {
  const [timeLeft, setTimeLeft] = useState(
    () => targetUnixTimestamp - Math.floor(Date.now() / 1000)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  if (timeLeft <= 0) {
    return null;
  }

  return (
    <Text
      component="span"
      type="paragraph"
      size="s"
      weight={600}
      className="text-[#2D7FF9]"
    >
      {formatTime(timeLeft)}
    </Text>
  );
};
